import { CssBaseline, ThemeProvider } from '@mui/material';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import { ThemeContext } from '@rumblefish/ui/context/themeContext/themeContext';
import { themeDark } from '../theme/rumblefish23Theme';
import store from '@rumblefish/ui/redux/configureStore';
import { Provider } from 'react-redux';

// Stable emotion cache for tests — prevents class name counter from
// drifting between environments (Windows vs Linux CI).
const testCache = createCache({ key: 'css' });
export const RenderWithThemeProvider: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <ThemeContext.Provider
      value={{
        theme: {
          type: 'light',
        },
        changeTheme: () => true,
        changeScrollTarget: (_el: HTMLElement | null) => undefined,
        scrollTarget: null,
        setLenis: () => null,
        lenis: null,
      }}>
      {children}
    </ThemeContext.Provider>
  );
};
export const RenderWithRumbleFish23Theme: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <CacheProvider value={testCache}>
      <Provider store={store}>
        <RenderWithThemeProvider>
          <ThemeProvider theme={themeDark}>
            <CssBaseline />
            {children}
          </ThemeProvider>
        </RenderWithThemeProvider>
      </Provider>
    </CacheProvider>
  );
};
